<template>
  <div class="space-y-8 p-6">
    <!-- Page title -->
    <R3Title title="Reporting ❯ Inventory Forecasting" />
    <!-- HEADER (metrics + filters) -->
    <DashboardHeader @filter-change="updateFilters" />

    <!-- CHARTS -->
      <div class="content-block dx-card responsive-paddings" style="background-color:#2b2b34;">
      <div class="grid gap-6">
        <TankForecastChart
          v-if="layoutReady"
          class="w-full"
        />
      </div>
    </div>

    <!-- TABLE -->
    <div class="content-block dx-card responsive-paddings" style="background-color:#2b2b34;">
      <CriticalTanksTable
        v-if="layoutReady"
        class="w-full"
      />
    </div>

    <!-- Floating assistant toggle button (teleported to <body> for true viewport anchoring) -->
    <teleport to="body">
      <DxButton
        icon="comment"
        styling-mode="contained"
        type="default"
        class="ai-assistant-toggle"
        @click="toggleAssistant"
      />
    </teleport>

    <!-- AI Assistant slide-over -->
    <AIAssistant :is-open="isAssistantOpen" @close="isAssistantOpen = false" />
  </div>
</template>

<script setup>
/* global defineEmits */


import {
  DashboardHeader,
  TankForecastChart,
  CriticalTanksTable,
  AIAssistant,
} from './index.js';

import R3Title from '@/components/base/page-title.vue';

import { reactive, ref, onMounted, onBeforeUnmount } from 'vue';
import DxButton from 'devextreme-vue/button';

// Local filters state – will eventually drive API calls
const filters = reactive({
  dateRange: [new Date(2025, 0, 1), new Date()],
  productId: null,
  locationId: null,
});

function updateFilters(payload) {
  Object.assign(filters, payload);
  // TODO: hook into API calls later
}

// AI Assistant state & helpers
const isAssistantOpen = ref(false);
function toggleAssistant() {
  isAssistantOpen.value = !isAssistantOpen.value;
}

// Delay-heavy widgets until layout settled
const layoutReady = ref(false);

onMounted(() => {
  // Wait one animation frame to ensure CSS, fonts, and media queries are applied
  requestAnimationFrame(() => {
    layoutReady.value = true;
  });
});

function handler(e) {
  if (e.ctrlKey && e.shiftKey && e.key.toLowerCase() === 'a') {
    e.preventDefault();
    toggleAssistant();
  }
}

onMounted(() => window.addEventListener('keydown', handler));
onBeforeUnmount(() => window.removeEventListener('keydown', handler));
</script>

<style>
/* Ensure the assistant toggle button always behaves as a floating widget */
.ai-assistant-toggle {
  position: fixed !important;
  bottom: 1.5rem !important; /* Tailwind`s bottom-6 */
  right: 1.5rem !important;  /* Tailwind`s right-6 */
  z-index: 1000 !important;  /* Above devextreme popups but below modals */

  /* Size / shape to mimic a floating circular FAB */
  width: 3rem !important;  /* w-12 */
  height: 3rem !important; /* h-12 */
  border-radius: 9999px !important; /* rounded-full */

  /* Shadow for elevation */
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3) !important;
}
</style>
